import React from 'react';
import Tabs from '../components/ui/Tabs';

export type POAViewMode = 'grid' | 'agenda';

interface Props {
  value: POAViewMode;
  onChange: (next: POAViewMode) => void;
}

/** Compact tab pair for POA layout mode. */
const ViewToggle: React.FC<Props> = ({ value, onChange }) => {
  const opts: { key: POAViewMode; label: string; icon: React.ReactNode }[] = [
    {
      key: 'grid',
      label: 'Grid',
      icon: (
        <svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden>
          <rect x="2" y="2" width="5" height="5" rx="1" /><rect x="9" y="2" width="5" height="5" rx="1" />
          <rect x="2" y="9" width="5" height="5" rx="1" /><rect x="9" y="9" width="5" height="5" rx="1" />
        </svg>
      ),
    },
    {
      key: 'agenda',
      label: 'Agenda',
      icon: (
        <svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden>
          <path d="M3 4h10M3 8h10M3 12h10" strokeLinecap="round" />
        </svg>
      ),
    },
  ];

  return <Tabs label="View mode" tabs={opts} value={value} onChange={(key) => onChange(key as POAViewMode)} size="sm" />;
};

export default ViewToggle;
